import { render } from "./Wisdom.vue?vue&type=template&id=afecddd8&scoped=true&ts=true"
import script from "./Wisdom.vue?vue&type=script&lang=ts"
export * from "./Wisdom.vue?vue&type=script&lang=ts"

import "./Wisdom.vue?vue&type=style&index=0&id=afecddd8&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afecddd8"]])

export default __exports__